var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHildSeat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 1000 1100",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M828 1077 c-28 -21 -53 -53 -73 -92 -28 -56 -30 -67 -30 -175 0 -63 4 -167 9 -230 l9 -116 -32 -27 c-38 -31 -47 -32 -161 -12 -189 33 -241 14 -304 -113 -43 -85 -53 -82 304 -82 234 0 310 3 318 13 5 6 49 191 97 410 71 326 84 401 74 413 -23 27 -67 44 -118 44 -40 0 -57 -6 -93 -33z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M644 1031 c-34 -21 -64 -75 -64 -116 0 -53 49 -125 86 -125 7 0 13 29 16 79 3 58 11 93 30 130 l25 51 -31 0 c-17 0 -45 -9 -62 -19z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M356 784 c-29 -29 -19 -61 42 -126 l59 -62 57 10 c31 6 58 9 60 7 5 -5 -15 -86 -24 -96 -4 -5 -41 -3 -81 3 -71 12 -77 11 -154 -16 -66 -24 -81 -34 -89 -57 -7 -19 -6 -31 2 -39 8 -8 21 -2 51 25 56 51 106 62 206 47 44 -7 105 -14 137 -17 80 -7 85 4 67 159 -8 78 -17 118 -25 118 -6 0 -47 -7 -90 -16 l-78 -16 -43 46 c-45 48 -71 56 -97 30z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M280 141 c0 -22 4 -42 10 -46 12 -8 518 -8 530 0 6 4 10 24 10 46 l0 39 -275 0 -275 0 0 -39z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHildSeat);
export default __webpack_public_path__ + "static/media/сhild-seat.4413ae6db6547085c1e2887e7539907b.svg";
export { ForwardRef as ReactComponent };